import { useTranslation } from 'i18n';

import {
  THEME_DEFAULT,
  COMPONENT_SIGNUP_BOX,
  COMPONENT_FOOTER,
} from 'consts/theme';
import { getTheme } from 'utils/theme';

export const getThemeComponents = () => ({
  [THEME_DEFAULT]: {
    [COMPONENT_SIGNUP_BOX]: true,
    [COMPONENT_FOOTER]: null,
  },
});

/**
 * Hook for requesting theme components.
 *
 * @returns a list of components that be displayed for the current theme (boolean, object, string etc.)
 *
 * @export
 * @param {Array} requestedComponents list of components to check against
 *
 * @example
 *
 * const [hasSignupBox, welcomeTitle] = useThemeComponents(COMPONENT_SIGNUP_BOX, COMPONENT_SIGNIN_TITLE);
 */
export default function useThemeComponents(...requestedComponents) {
  const { t } = useTranslation();
  const themeComponents = getThemeComponents(t);
  const currentThemeComponents = themeComponents[getTheme()];

  return requestedComponents.map(
    (component) => currentThemeComponents[component] || null,
  );
}
